<div class="container sms006">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblName}}</mat-label>
          </div>
          <br>
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
          </div>
          <br>

          <mat-label class="message">{{lblMessage02}}</mat-label>
          <div>
            <fieldset class="grid-frame">
              <div class="grid-row">
                <mat-label class="grid-yatin-yyyymm">{{lblYatinYm}}</mat-label>
                <mat-label class="grid-yatin-kingaku">{{lblSeikyuGaku}}</mat-label>
              </div>
              <div class="grid-row">
                <mat-label class="grid-yatin-msg">{{lblMessage03}}</mat-label>
              </div>
            </fieldset>
          </div>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblShutokuDate}}</mat-label>
          </div>

        </div>
      </form>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button (click)="backClick()" accesskey="q" tabindex="1">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
